// components/SkeletonLoader.js
import React from "react";
import "../styles/SkeletonLoader.css"; // We'll create this CSS next

export default function SkeletonLoader() {
  return (
    <div className="skeleton-loader">
      <div className="skeleton-heading"></div>
      <div className="skeleton-paragraph"></div>
      <div className="skeleton-paragraph short"></div>
      <div className="skeleton-box"></div>
      <div className="skeleton-box"></div>
      <div className="skeleton-box"></div>
    </div>
  );
}
